import React from "react";
import { useTheme, styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import MobileStepper from "@mui/material/MobileStepper";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import budgit from "../../../images/portfolio/budgit.png";
import cacer from "../../../images/portfolio/covid.png";
import yvotenaija from "../../../images/portfolio/yvotenaija.png";
import grap from "../../../images/portfolio/grap.png";
import linker from "../../../images/portfolio/linker.png";
import login from "../../../images/portfolio/login.png";
import ysl from "../../../images/portfolio/ysl.png";
import lawyer from "../../../images/portfolio/lawyers.jpg";
import amplify from "../../../images/portfolio/amplify.jpg";
import nanya from "../../../images/portfolio/nanya.jpg";
import earth from "../../../images/portfolio/earth.jpg";
import cleanup from "../../../images/portfolio/cleanup.jpg";
import ecocyclers from "../../../images/portfolio/eco-cyclers.jpg";
import jurstice from "../../../images/portfolio/jurstice.jpg";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
  {
    img: "gallery_img_1",
    title: "ACA Awards",
    intro:
      "Active Citizen Award is BudgIT’s initiative and signature move to spotlight and appreciate personalities, organizations and agencies doing these ground-breaking humanitarian work in Nigeria.",
    imgPath: budgit,
    category: "Web Development",
    industry: "Civic Society/NGO",
  },
  {
    img: "gallery_img_7",
    title: "YSL Realtors",
    intro:
      "YSL Realtors Ltd is a real estate company in Nigeria with primary interest in construction, real estate development, facility management and investment.",
    imgPath: ysl,
    category: "Web Development",
    industry: "Real Estate Development",
  },
  {
    img: "gallery_img_2",
    title: "CACER",
    intro:
      "The project is focused on Advancing Community Access to Equitable COVID-19 Response (CACER) in three West African countries - Nigeria, Senegal and Ghana.",
    imgPath: cacer,
    category: "Web Development",
    industry: "Consulting",
  },
  {
    img: "gallery_img_3",
    title: "YVoteNaija",
    intro:
      "YVoteNaija is an initiative of Brain Builders Youth development Initiative which aims at increasing voter education through data driven engagement, orientating young Nigerians on the importance of getting involved in the process especially at the grassroot level.",
    imgPath: yvotenaija,
    category: "Web Development",
    industry: "Civic Society/NGO",
  },
  {
    img: "gallery_img_4",
    title: "GRAP",
    intro:
      "GRAP is a civic-tech initiative for budget participation by PROMAD—using tech to document the NEEDS of Nigerian communities for adoption into the annual budget.",
    imgPath: grap,
    category: "Web Development",
    industry: "Civic Society/NGO",
  },
  {
    img: "gallery_img_5",
    title: "LOGIN",
    intro:
      "LOGIN is an emerging civic hub aimed at launching strategic cum calculated design-thinking civic action melded with tech premised on Open Governance System for tracking/monitoring projects, budgets, expenditures.",
    imgPath: login,
    category: "Web Development",
    industry: "Civic Society/NGO",
  },
  {
    img: "gallery_img_6",
    title: "Linker",
    intro:
      "Linker is a civic-tech idea of Levite Foundation for Community Development, designed to build a society where all spheres of governance work for all citizens irrespective of their social status, literacy level, disability or geographical location.",
    imgPath: linker,
    category: "Web Development",
    industry: "Civic Society/NGO",
  },
  {
    img: "gallery_img_8",
    title: "Lawyers NowNow",
    intro:
      "Lawyers NowNow is a cutting-edge JusticeTech product designed by the Headfort Foundation for Justice. As a technology-driven platform, they aim to revolutionize access to legal aid in Nigeria by breaking down the barriers that often prevent marginalized and vulnerable communities from seeking justice.",
    imgPath: lawyer,
    category: "Web Development",
    industry: "Civic Society/NGO",
  },
  {
    img: "gallery_img_9",
    title: "Nanya's Care Initiative",
    intro:
      "Nanya's Care Initiative is an Anambra-based organization that is dedicated to creating a more just, equitable, and inclusive society by addressing systemic challenges in gender equality, social justice, and education.",
    imgPath: nanya,
    category: "Web Development",
    industry: "Civic Society/NGO",
  },
  {
    img: "gallery_img_10",
    title: "Cleanup Initiative",
    intro:
      "CleanUp Initiative believes in the power of small actions to create big change and their mission is to reduce plastic waste and make the world a cleaner, more sustainable place.",
    imgPath: cleanup,
    category: "Web Development",
    industry: "Civic Society/NGO",
  },
  {
    img: "gallery_img_11",
    title: "Eco-Cyclers",
    intro:
      "Eco-Cyclers began as a grassroots initiative in Enugu State, Nigeria, with a vision to tackle the pressing issue of plastic waste through community-driven recycling and environmental education.",
    imgPath: ecocyclers,
    category: "Web Development",
    industry: "Civic Society/NGO",
  },
  {
    img: "gallery_img_12",
    title: "Amplify Youth Initiative",
    intro:
      "Amplify Youth Initiative is a youth-led organization dedicated to driving impactful change in Nigeria through justice reform, youth empowerment, and inclusive governance.",
    imgPath: amplify,
    category: "Web Development",
    industry: "Civic Society/NGO",
  },
  {
    img: "gallery_img_13",
    title: "Egalitarianism for Earth",
    intro:
      "Egalitarianism For Earth is an initiative aimed at raising awareness about climate change and environmental degradation among young individuals making sure that they are passionate and have a sense of environmental stewardship inculcated in them.",
    imgPath: earth,
    category: "Web Development",
    industry: "Civic Society/NGO",
  },
  {
    img: "gallery_img_14",
    title: "Jurstice Tender",
    intro:
      "Jurstice Tender provides grassroots, tech-enabled access to justice through our network of trained agents and locally accessible legal aid solutions.",
    imgPath: jurstice,
    category: "Web Development",
    industry: "Civic Society/NGO",
  },
];

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  dot: {
    backgroundColor: "#aaa",
  },
  dotActive: {
    backgroundColor: "#33E68C",
  },
});

const ColorButton = styled(Button)(() => ({
  color: "#000",
}));

const Gallery = () => {
  const theme = useTheme();
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Box
      display="flex"
      justifyContent={"space-between"}
      alignItems={"flex-start"}
      flexWrap={"wrap"}
      marginTop={{ xs: "5%", sm: "5%" }}
    >
      <Box
        width={{ xs: "100%", sm: "69%" }}
        marginBottom={{ xs: "10%", sm: "5%" }}
      >
        <AutoPlaySwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
          interval={5000}
        >
          {images.map((step, index) => (
            <div key={step.img}>
              {Math.abs(activeStep - index) <= 2 ? (
                <Box>
                  <Box
                    component="img"
                    height={{ xs: "21vh", sm: "400px" }}
                    sx={{
                      display: "block",
                      overflow: "hidden",
                      width: "100%",
                    }}
                    src={step.imgPath}
                    alt={step.img}
                  />
                </Box>
              ) : null}
            </div>
          ))}
        </AutoPlaySwipeableViews>
        <MobileStepper
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          classes={{
            root: classes.root,
            dot: classes.dot,
            dotActive: classes.dotActive,
          }}
          sx={{ color: "#000" }}
          nextButton={
            <ColorButton
              size="small"
              onClick={handleNext}
              disabled={activeStep === maxSteps - 1}
            >
              Next
              {theme.direction === "rtl" ? (
                <KeyboardArrowLeft />
              ) : (
                <KeyboardArrowRight />
              )}
            </ColorButton>
          }
          backButton={
            <ColorButton
              size="small"
              onClick={handleBack}
              disabled={activeStep === 0}
            >
              {theme.direction === "rtl" ? (
                <KeyboardArrowRight />
              ) : (
                <KeyboardArrowLeft />
              )}
              Back
            </ColorButton>
          }
        />
      </Box>
      <Box width={{ xs: "100%", sm: "20%" }} marginTop={{ xs: "5%", sm: "0%" }}>
        <Typography
          variant="h3"
          color={"#000"}
          paddingBottom={"5%"}
          fontWeight={700}
        >
          {images[activeStep].title}
        </Typography>
        <Typography
          variant="body2"
          color={"#000"}
          paddingBottom={{ xs: "5%", sm: "15%" }}
          lineHeight={"1.625em"}
        >
          {images[activeStep].intro}
        </Typography>
        <Typography
          variant="body2"
          color={"#000"}
          paddingBottom={"2%"}
          fontWeight={700}
        >
          Category: {images[activeStep].category}
        </Typography>
        <Typography
          variant="body2"
          color={"#000"}
          paddingBottom={"2%"}
          fontWeight={700}
        >
          Industry: {images[activeStep].industry}
        </Typography>
      </Box>
    </Box>
  );
};

export default Gallery;
